import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "navbar-nav justify-content-end flex-grow-1 pe-3" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, i) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "nav-item col-12 col-md-auto",
        key: i
      }, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link rounded position-relative w-100", _ctx.$route.name == link.name ? 'active disabled' : '']),
          "aria-current": "page",
          "data-bs-dismiss": "offcanvas",
          onClick: ($event: any) => (_ctx.$router.push({ name: link.name })),
          style: {"cursor":"pointer"}
        }, _toDisplayString(_ctx.$t(`nav.${link.name}`)), 11, _hoisted_2)
      ]))
    }), 128)),
    _renderSlot(_ctx.$slots, "default")
  ]))
}